export default function Terms() {
  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <h1 className="text-3xl font-bold mb-4 text-gray-900">Terms of Use</h1>
      <p className="text-lg text-gray-700 mb-2">
        By using HollerFinds, you agree to be kind, neighborly, and honest. Please only post items or events that are legal, safe, and truly available.
      </p>
      <p className="text-lg text-gray-700 mb-2">
        We reserve the right to remove any content that doesn't fit our community guidelines or spirit of generosity.
      </p>
      <p className="text-lg text-gray-700">
        HollerFinds is provided as-is, without warranty. Use common sense and always meet in safe, public places.
      </p>
    </main>
  );
} 